import { Button, Form, Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import CGULink from '../../assets/pdf/CGU.pdf';
import Up from '../../assets/svg/Up';

export const isDesktop = () => {
  return (
    !/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(navigator.userAgent) &&
    !/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      navigator.userAgent
    )
  );
};
const ModalCGU = (props: any) => {
  const handleClose = () => {
    props.setShow(false);
  };

  return (
    <Modal className="modal-team" show={props.show} onHide={handleClose}>
      <div className="d-flex flex-column justify-content-center m-4 mb-2">
        <div className="mb-1 d-flex flex-row justify-content-between">
          <div className="d-flex flex-row justify-content-start gap-2 mb-0 pb-0">
            <h4 className="short-agenda-modal mt-3 pt-2">
              <p className="fw-bold">CGU : </p>
            </h4>
          </div>
          <Button variant="none" onClick={handleClose}>
            <Up color="#000D5B" />
          </Button>
        </div>
        {isDesktop() && <embed className="embed-pdf mb-2" src={CGULink} type="application/pdf" />}
        {!isDesktop() && (
          <Link target="_BLANK" className="link" to={CGULink}>
            Cliquez ici pour visualisez les CGV et CGU
          </Link>
        )}
        {props.checkCGU !== undefined && (
          <Form.Group className="mb-4 mt-4" controlId="cguModal">
            <Form.Check
              className="text"
              type="checkbox"
              onChange={() => {
                props.setCheckCGU(!props.checkCGU);
                props.changeCheckAll(!props.checkCGU);
              }}
              checked={props.checkCGU}
              label="En cochant cette case, je reconnais avoir pris connaissance des Conditions Générales d'Utilisation de dwell et je les accepte"
            />
          </Form.Group>
        )}
      </div>
    </Modal>
  );
};

export default ModalCGU;
